import {JSX} from 'react';
import './button.css';

interface ButtonProps {
  image: string;
  title?: string;
  onClick?: () => void; 
}

const Button = ({ image, title = 'Add', onClick }: ButtonProps): JSX.Element => {  // Removed React.FC
  return (
    <div className='button-container' onClick={onClick}>
      <img
        src={image}
        className='button-img'
        alt={title}
      />
      <p className='button-title'>{title}</p>
    </div>
  ); 
};

export default Button;